export const iconFontAwesomeConstructionRuler = (
	<i className="fa-solid fa-ruler"></i>
);
